/**
 * Variant Gallery Sync — Worn In Public / Horizon
 * When a color variant is selected, scrolls the media gallery
 * to the featured image assigned to that variant.
 */

(function () {
  function getProductData() {
    const el = document.getElementById('product-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function syncGalleryToVariant(variantId, product) {
    const variant = product.variants.find(v => v.id === variantId);
    if (!variant || !variant.featured_media) return;

    const mediaId = variant.featured_media.id;

    // Horizon uses data-media-id on gallery items
    const galleryItems = document.querySelectorAll('[data-media-id]');
    galleryItems.forEach(item => {
      if (parseInt(item.dataset.mediaId) === mediaId) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        item.click(); // triggers Horizon's native gallery viewer
      }
    });
  }

  function init() {
    const product = getProductData();
    if (!product) return;

    // Listen for Shopify's native variant change event
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail?.variant;
      if (variant) syncGalleryToVariant(variant.id, product);
    });

    // Also listen for custom events some themes dispatch
    document.addEventListener('variantChange', (e) => {
      const variant = e.detail?.variant;
      if (variant) syncGalleryToVariant(variant.id, product);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
